window.app.directive('emailConfirmed', ($http, $q) => {
    return {
        require: 'ngModel',
        link: (scope, element, attrs, ngModel) => {
            ngModel.$asyncValidators.emailConfirmed = (modelValue, viewValue) => {
                console.log('Email confirmed', scope.emailChecks);
                if (typeof scope.emailChecks[modelValue] !== 'undefined') {
                    const userData = scope.emailChecks[modelValue];
                    const def = $q.defer();

                    return $timeout(() => {
                        if (!userData.userExists) def.reject();
                        def.resolve();
                    }, 100);
                } else {
                    $http.post(attrs.emailConfirmed, {email: viewValue})
                        .then(response => {
                            console.log(response);
                            scope.emailChecks[modelValue] = response.data;
                            if (response.data.userExists && !response.data.emailConfirmed) {
                                scope.authForm.authSection.email.$setValidity('emailConfirmed', false);
                                return $q.reject('Email not confirmed!');
                            } else {
                                scope.authForm.authSection.email.$setValidity('emailConfirmed', true);
                                return $q.resolve();
                            }
                        }
                    );
                }
            };
        }
    }
});


// WEBPACK FOOTER //
// src/js/validators/emailConfirmed.js